import React, { useEffect, useRef, useState } from "react";
import { formatDate } from "../../../../../../utils/commonFunctions";
import { Card, message } from "antd";
import swal from "sweetalert";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import ReactLoading from "react-loading";
import {
  calculateAgeFormDOB,
  hasNumeric,
  hasSpecialCharacter,
  isNameValid,
  isValidAddress,
} from "./commonfunctions";
import useAxios from "../../../../../../hooks/useAxios";

function Accidental({
  form,
  filledForm,
  getAllJoiningFilledForms,
  aadharDetails,
  metaData,
  setAccidentalPreviewData,
  setActivePanel,
  application,
  setIsFieldTouch,
}) {
  let _aadhar = aadharDetails || {};
  const IS_DISABLE =
    filledForm?.formStatusByHR === false
      ? !application?.candidateSignatureStatus
        ? true
        : false
      : false;

  const { house, street, state, loc, dist } =
    _aadhar?.aadharVerificationDetails?.data?.address || {};

  const ADDRESS =
    _aadhar?.aadharVerificationDetails?.data?.full_address ||
    [house, street, state, loc, dist].filter(Boolean).join(", ") ||
    "";
  const DOB = application?.responses?.find(
    (item) => item?.label === "Date of Birth"
  )?.value;

  const api = useAxios();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name: filledForm?.documentDetails?.name || "",
    residential_address:
      filledForm?.documentDetails?.residential_address ||
      (ADDRESS ? ADDRESS : undefined) ||
      metaData?.permanent_address ||
      "",
    dob:
      filledForm?.documentDetails?.dob ||
      _aadhar?.aadharVerificationDetails?.data?.dob ||
      DOB ||
      "",
    age:
      filledForm?.documentDetails?.age ||
      calculateAgeFormDOB(
        filledForm?.documentDetails?.dob ||
          _aadhar?.aadharVerificationDetails?.data?.dob ||
          DOB
      ).toString() ||
      "",
    disability: filledForm?.documentDetails?.disability || "",
    // place: filledForm?.documentDetails?.place || "",
    assignment_name:
      filledForm?.documentDetails?.assignment_name ||
      _aadhar?.aadharVerificationDetails?.data?.full_name ||
      (metaData?.first_name || metaData?.last_name
        ? `${metaData?.first_name} ${metaData?.last_name}`
        : undefined) ||
      "",
    death_name: filledForm?.documentDetails?.death_name || "",
    assignment_relation: filledForm?.documentDetails?.assignment_relation || "",
  });
  const [loading, setLoading] = useState(false);
  const [officeAddr, setOfficeAddr] = useState(
    filledForm?.documentDetails?.office_address || ""
  );
  const [error, setError] = useState({});

  const handleChange = (e) => {
    setIsFieldTouch(true);
    const { name, value } = e.target;

    if (name === "dob") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        age: calculateAgeFormDOB(value).toString(),
      }));
      return;
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const isFormDataEmpty = () => {
    for (let key in formData) {
      if (formData[key].trim() === "") {
        return true;
      }
    }
    return false;
  };

  const validateInput = (e) => {
    if (isFormDataEmpty()) {
      return true;
    }

    return false;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let flag = false;
    for (let key in error) {
      if (error[key] !== "") {
        flag = true;
        break;
      }
    }

    if (flag) {
      swal({
        title: "Error",
        // text: "Are you sure you want to Approve? Before on-boarding the candidate, please cross verify the TRF.",
        icon: "error",
        content: {
          element: "div",
          attributes: {
            innerHTML: `
                  <p style="text-align:center">Before submit please resolve all the errors.</p>       
                `,
          },
        },
        buttons: {
          cancel: false,
          confirm: true,
        },
      }).then((flag) => {});
      return;
    }

    const data = {
      companyDocumentId: form?._id,
      candidateId: id,
      documentDetails: {
        ...formData,
        ...(officeAddr !== "" ? { office_address: officeAddr } : {}),
      },
      formStatus: true,
    };

    try {
      setLoading(true);
      await api.post(`/companyDocuments/DocumentMaping`, data, {
        tokenType: "candidate",
      });
      await getAllJoiningFilledForms();
      message.success("Your form has been submitted successfully!");
      setActivePanel(null);
      setLoading(false);
      setIsFieldTouch(false);
    } catch (err) {
      setLoading(false);
    }
  };

  useEffect(() => {
    setAccidentalPreviewData({
      ...formData,
      ...(officeAddr !== "" ? { office_address: officeAddr } : {}),
    });

    let e = {};

    if (formData?.name.trim()) {
      e.name = isNameValid(formData.name);
    }

    // if (formData?.assignment_name.trim()) {
    //   e.assignment_name = isNameValid(formData.assignment_name);
    // }

    if (formData?.death_name.trim()) {
      e.death_name = isNameValid(formData.death_name);
    }

    // if (formData?.residential_address.trim()) {
    //   e.residential_address = isValidAddress(formData.residential_address);
    // }

    if (officeAddr.trim()) {
      e.office_address = isValidAddress(officeAddr);
    }

    if (
      formData?.assignment_relation &&
      formData?.assignment_relation?.trim().length < 3
    ) {
      e.assignment_relation = "Relation must be more than 3 char.";
    } else {
      if (
        hasNumeric(formData.assignment_relation?.trim()) ||
        hasSpecialCharacter(formData.assignment_relation?.trim())
      ) {
        e.assignment_relation = "No numeric or special character allowed.";
      } else {
        e.assignment_relation = "";
      }
    }

    // if (formData?.place && formData?.place?.trim().length < 3) {
    //   e.place = "Place must be more than 3 char.";
    // } else {
    //   if (
    //     hasNumeric(formData.place?.trim()) ||
    //     hasSpecialCharacter(formData.place?.trim())
    //   ) {
    //     e.place = "No numeric or special character allowed.";
    //   } else {
    //     e.place = "";
    //   }
    // }

    // if (formData.age && formData.age < 18) {
    //   e.age = "Age must be greater than or equal to 18";
    // } else {
    //   e.age = "";
    // }

    // if (new Date(formData.dob) > new Date()) {
    //   e.dob = "Future date is not allowed.";
    // } else {
    //   e.dob = "";
    // }

    setError(e);
  }, [formData, officeAddr]);

  return (
    <Card>
      {loading ? (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      ) : (
        <div className="row">
          <div className="col-12">
            <p style={{ color: "red", fontSize: "14px" }}>
              <strong>Note:</strong> All fields marked with an asterisk (
              <span style={{ color: "red" }}>*</span>) are mandatory.
            </p>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Name of The Proposer
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  disabled={filledForm?.formStatusByHR}
                  name="name"
                  onChange={handleChange}
                  style={{
                    ...(error?.name ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.name.replaceAll(/\b[a-z]/g, (p) =>
                    p.toUpperCase()
                  )}
                />
                {error?.name && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.name}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Residential Address
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  disabled={filledForm?.formStatusByHR || true}
                  name="residential_address"
                  onChange={handleChange}
                  style={{
                    ...(error?.residential_address
                      ? { border: "1px solid red" }
                      : {}),
                  }}
                  value={formData?.residential_address}
                />
                {error?.residential_address && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.residential_address}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">Office Address</label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="office_address"
                  disabled={filledForm?.formStatusByHR}
                  onChange={(e) => setOfficeAddr(e.target.value)}
                  style={{
                    ...(error?.office_address
                      ? { border: "1px solid red" }
                      : {}),
                  }}
                  value={officeAddr}
                />
                {error?.office_address && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.office_address}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Date of Birth
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="date"
                  disabled={filledForm?.formStatusByHR || true}
                  name="dob"
                  max={formatDate(new Date())}
                  onChange={handleChange}
                  style={{
                    ...(error?.dob ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.dob}
                />
                {error?.dob && (
                  <p style={{ color: "red", fontSize: "10px" }}>{error?.dob}</p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Age
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="number"
                  disabled={filledForm?.formStatusByHR || true}
                  name="age"
                  min={0}
                  onChange={handleChange}
                  style={{
                    ...(error?.age ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.age}
                />
                {error?.age && (
                  <p style={{ color: "red", fontSize: "10px" }}>{error?.age}</p>
                )}
              </div>
              <div className="form-group mb-3 col-md-4 form-builder-element">
                <label htmlFor="">
                  Are You Suffering From Any Disability
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-3">
                    <input
                      id="yes"
                      disabled={filledForm?.formStatusByHR}
                      name="disability"
                      type="radio"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="Yes"
                      checked={formData?.disability === "Yes"}
                    />
                    <label htmlFor="yes" className="custom-control-label">
                      Yes
                    </label>
                  </div>

                  <div className="custom-control custom-radio mx-3">
                    <input
                      disabled={filledForm?.formStatusByHR}
                      id="no"
                      name="disability"
                      type="radio"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="No"
                      checked={formData?.disability === "No"}
                    />
                    <label htmlFor="no" className="custom-control-label">
                      No
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Assignment Name
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="assignment_name"
                  disabled={filledForm?.formStatusByHR || true}
                  onChange={handleChange}
                  style={{
                    ...(error?.assignment_name
                      ? { border: "1px solid red" }
                      : {}),
                  }}
                  value={formData?.assignment_name.replaceAll(/\b[a-z]/g, (p) =>
                    p.toUpperCase()
                  )}
                />
                {error?.assignment_name && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.assignment_name}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Assignment Death Person Name
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="death_name"
                  disabled={filledForm?.formStatusByHR}
                  onChange={handleChange}
                  style={{
                    ...(error?.death_name ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.death_name.replaceAll(/\b[a-z]/g, (p) =>
                    p.toUpperCase()
                  )}
                />
                {error?.death_name && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.death_name}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Assignment Relation
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="assignment_relation"
                  disabled={filledForm?.formStatusByHR}
                  onChange={handleChange}
                  style={{
                    ...(error?.assignment_relation
                      ? { border: "1px solid red" }
                      : {}),
                  }}
                  value={formData?.assignment_relation}
                />
                {error?.assignment_relation && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.assignment_relation}
                  </p>
                )}
              </div>
              {/* <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Place
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="place"
                  disabled={filledForm?.formStatusByHR}
                  onChange={handleChange}
                  style={{
                    ...(error?.place ? { border: "1px solid red" } : {})
                  }}
                  value={formData?.place}
                />
                {error?.place && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.place}
                  </p>
                )}
              </div> */}
            </div>
            <div className="row">
              <div className="col-12 d-flex justify-content-center">
                <button
                  className={`btn ${
                    filledForm?.formStatusByHR || validateInput() || IS_DISABLE
                      ? "btn-secondary"
                      : "btn-primary"
                  } `}
                  onClick={handleSubmit}
                  disabled={
                    validateInput() || filledForm?.formStatusByHR || IS_DISABLE
                  }
                >
                  <span className="pr-2">
                    <i className="fa fa-paper-plane" aria-hidden="true"></i>
                  </span>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Card>
  );
}

export default Accidental;
